import React, { Component } from 'react';
import GeoApi from '../api/destinations';

class CityName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      city: false,
      country_name: false,
    };
  }

  async componentDidMount() {
    this.searchIataCode();
  }

  searchIataCode = () => {
    if (this.props.code && this.props.code.length === 3) {
      GeoApi.getCityByCode(this.props.code).then((res) => {
        this.setState({
          city: res.name,
          countryName: res.country_name,
        });
      }).catch((err) => { console.error(err); });
    }
  }

  render() {
    if (!this.props.code && this.props.code === '') {
      return (
        <span>{` ${this.props.code}`}</span>
      );
    }
    const text = () => {
      let humanised = this.props.code;
      if (this.state.city) {
        if (this.props.fullName) {
          humanised = `${this.state.city}, ${this.state.countryName}`;
        } else {
          humanised = this.state.city;
        }
        if (this.props.upperCase) {
          humanised = humanised.toUpperCase();
        }
      }
      return humanised;
    };

    return (
      <span>{text()}</span>
    );
  }
}

export default CityName;
